<template>
    <div class="ops-page">
        <!-- 面包屑 -->
        <div class="ops-crumb"><span>人群运营</span> / <b>运营任务</b></div>

        <!-- 头部 -->
        <div class="ops-head">
            <h1 class="page-title">运营任务<small>共 {{ total }} 个任务</small></h1>
            <div class="grow"></div>
            <button class="btn-primary" @click="goCreate">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.4"><path d="M12 5v14M5 12h14"/></svg>
                新建任务
            </button>
        </div>

        <!-- KPI 卡片 -->
        <div class="ops-kpi-row">
            <div class="ops-kpi-card">
                <div class="ops-kpi-ico" style="background:linear-gradient(135deg,#4F46E5,#7C3AED)">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg>
                </div>
                <div>
                    <div class="ops-kpi-num">{{ kpi.total }}</div>
                    <div class="ops-kpi-label">任务总数</div>
                    <div class="ops-kpi-sub up">进行中 {{ kpi.running }} 个</div>
                </div>
            </div>
            <div class="ops-kpi-card">
                <div class="ops-kpi-ico" style="background:linear-gradient(135deg,#10B981,#059669)">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>
                </div>
                <div>
                    <div class="ops-kpi-num">{{ kpi.running }}</div>
                    <div class="ops-kpi-label">进行中</div>
                    <div class="ops-kpi-sub flat">占总数 {{ kpi.runningRate }}%</div>
                </div>
            </div>
            <div class="ops-kpi-card">
                <div class="ops-kpi-ico" style="background:linear-gradient(135deg,#0EA5E9,#0284C7)">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>
                </div>
                <div>
                    <div class="ops-kpi-num">{{ fmtWan(kpi.reach) }}</div>
                    <div class="ops-kpi-label">累计发送客户</div>
                    <div class="ops-kpi-sub up">累计覆盖 {{ fmtInt(kpi.cover) }} 人</div>
                </div>
            </div>
            <div class="ops-kpi-card">
                <div class="ops-kpi-ico" style="background:linear-gradient(135deg,#F59E0B,#D97706)">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><path d="M3 3v18h18"/><path d="M7 14l4-4 3 3 5-6"/></svg>
                </div>
                <div>
                    <div class="ops-kpi-num">{{ fmtInt(kpi.conv) }}</div>
                    <div class="ops-kpi-label">累计发送失败</div>
                    <div class="ops-kpi-sub up">失败率 {{ kpi.convRate }}%</div>
                </div>
            </div>
        </div>

        <!-- 工具栏 -->
        <div class="ops-toolbar">
            <div class="ops-search">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#64748B" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
                <input v-model="state.kw" placeholder="搜索任务名称…" @input="onSearch" />
            </div>
            <div class="ops-tabs2">
                <button v-for="(st, key) in STATUS_TABS" :key="key" class="ops-tab2" :class="{ active: state.status === key }" @click="setStatus(key)">{{ st }}</button>
            </div>
            <div class="grow"></div>
            <span class="ops-filter-note">动作：内容推送 · 渠道：企微 1v1</span>
        </div>

        <!-- 任务表格 -->
        <div class="ops-tbl-card">
            <el-table
                :data="filteredTasks"
                :header-cell-style="{ background: '#FAFBFE', color: '#64748B', fontWeight: '700', fontSize: '12.5px' }"
                empty-text="没有符合条件的任务"
                style="width: 100%">
                <el-table-column label="任务名称" min-width="220">
                    <template #default="scope">
                        <div class="name-cell">{{ scope.row.name }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="目标人群" min-width="160">
                    <template #default="scope"><span class="muted-cell">{{ (scope.row.audience_names || []).join('、') || '—' }}</span></template>
                </el-table-column>
                <el-table-column label="运营动作" min-width="130">
                    <template #default="scope">
                        <span class="act-chip" style="background:#0EA5E922; color:#0EA5E9">{{ scope.row.action_type === 'push' ? '内容推送' : scope.row.action_type }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="触达渠道" min-width="150">
                    <template #default="scope">
                        <span class="ch-chip" style="background:#4F46E522; color:#4F46E5">{{ scope.row.send_channel === 'wecom_1v1' ? '企微 1v1' : scope.row.send_channel }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="触发时机" min-width="110">
                    <template #default="scope"><span class="muted-cell">{{ scope.row.trigger_type === 'now' ? '立即' : '定时' }}</span></template>
                </el-table-column>
                <el-table-column min-width="200">
                    <template #header>
                        <span class="th-tip">效果（总数/触达/唤醒）
                            <el-tooltip placement="top" effect="dark">
                                <template #content>
                                    <div class="th-tip-box">
                                        <div><em>总数</em>：本任务覆盖的客户总数</div>
                                        <div><em>触达</em>：成功触达的客户数（同一客户去重）</div>
                                        <div><em>唤醒</em>：触达后当天产生互动</div>
                                    </div>
                                </template>
                                <i class="tip-ico">?</i>
                            </el-tooltip>
                        </span>
                    </template>
                    <template #default="scope">
                        <div class="eff-trio">
                            <div class="eff-item"><b>{{ fmtInt(scope.row.cover_count) }}</b><i>总数</i></div>
                            <div class="eff-item"><b>{{ fmtInt(scope.row.sent_amount) }}</b><i>触达</i></div>
                            <div class="eff-item key"><b>{{ fmtInt(scope.row.wakeup_amount) }}</b><i>唤醒</i></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="状态" min-width="110">
                    <template #default="scope">
                        <el-tooltip :content="pauseTip(scope.row)" :disabled="!pauseTip(scope.row)" placement="top">
                            <span class="ops-badge" :class="STATUS_CLS[scope.row.status]">{{ scope.row.status_label }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" min-width="120">
                    <template #default="scope"><span class="muted-cell">{{ scope.row.created_at }}</span></template>
                </el-table-column>
                <el-table-column label="操作" min-width="130">
                    <template #default="scope">
                        <span v-if="scope.row.status === 0" class="op" @click="goEdit(scope.row)">编辑</span>
                        <span class="op" @click="openDetail(scope.row)">查看</span>
                        <span v-if="scope.row.status === 1 || scope.row.status === 2" class="op op-pause" @click="pauseTask(scope.row)">暂停</span>
                        <span v-else-if="scope.row.status === 4" class="op op-resume" @click="resumeTask(scope.row)">继续</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="ops-pager">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    :current-page="state.page"
                    :page-size="state.page_size"
                    :page-sizes="[10, 20, 50, 100]"
                    @current-change="onPageChange"
                    @size-change="onSizeChange" />
            </div>
        </div>

        <!-- 任务详情弹窗 -->
        <el-dialog v-model="detailVisible" title="任务详情" width="640px">
            <div v-loading="detailLoading" class="detail-body">
                <template v-if="detail">
                    <div class="detail-title">
                        <span class="detail-name">{{ detail.name }}</span>
                        <el-tooltip :content="pauseTip(detail)" :disabled="!pauseTip(detail)" placement="top">
                            <span class="ops-badge" :class="STATUS_CLS[detail.status]">{{ detail.status_label }}</span>
                        </el-tooltip>
                    </div>
                    <div class="detail-grid">
                        <div class="detail-item"><label>目标人群</label><span>{{ (detail.audience_names || []).join('、') || '—' }}</span></div>
                        <div class="detail-item"><label>运营动作</label><span>{{ detail.action_type === 'push' ? '内容推送' : detail.action_type }}</span></div>
                        <div class="detail-item"><label>触达渠道</label><span>{{ detail.send_channel === 'wecom_1v1' ? '企微 1v1' : detail.send_channel }}</span></div>
                        <div class="detail-item"><label>触发时机</label><span>{{ detail.trigger_type === 'now' ? '立即' : '定时' }}{{ detail.trigger_type === 'scheduled' && detail.execute_at ? ' · ' + detail.execute_at : '' }}</span></div>
                        <div class="detail-item"><label>触达频率</label><span>{{ detail.freq_mode ? detail.freq_mode + ' ≤ ' + detail.freq_num + ' 人' : '不限' }}</span></div>
                        <div class="detail-item"><label>发送间隔</label><span>{{ detail.gap_min || detail.gap_max ? detail.gap_min + ' ~ ' + detail.gap_max + ' 秒' : '—' }}</span></div>
                        <div class="detail-item full"><label>客户体验保护</label><span>{{ cxText }}</span></div>
                        <div class="detail-item full">
                            <label>效果</label>
                            <span>覆盖 {{ fmtInt(detail.cover_count) }} 人 · 已发送 {{ fmtInt(detail.sent_amount) }} · 待发送 {{ fmtInt(detail.to_send_amount) }} · 失败 {{ fmtInt(detail.sent_failed_amount) }}</span>
                        </div>
                        <div class="detail-item full"><label>创建时间</label><span>{{ detail.created_at || '—' }}</span></div>
                    </div>
                    <div class="detail-content">
                        <label>推送内容</label>
                        <div v-if="!detailContent.length" class="detail-empty">暂无内容</div>
                        <div v-for="(c, i) in detailContent" :key="i" class="detail-msg">
                            <img v-if="c.type === 'Picture'" :src="c.img" class="detail-img" alt="推送图片" />
                            <div v-else class="detail-text">{{ c.text }}</div>
                        </div>
                    </div>
                </template>
            </div>
            <template #footer>
                <button class="btn-primary" @click="detailVisible = false">关闭</button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
// 注意：本页面用普通 <script> + setup() 写法，不用 <script setup>。
// 原因：vue-cli4 内置的 vue-loader-v16 + @vue/compiler-sfc 3.2.34 在流水线环境下
// 对 <script setup> 编译偶发崩溃（Cannot read properties of null (reading 'content')），
// 普通 <script> 走简单编译路径，最稳定。改回 setup 前先确认流水线构建稳定。
import { ref, reactive, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { newgetcrowdopslist, newgetcrowdopsdetail, newpausecrowdops, newresumecrowdops, newgetcrowdopsstats } from '@/assets/js/common.js'
import { decode } from '@/assets/js/base64.js'

export default {
    setup() {
        const router = useRouter()

        /* ============== 常量 ============== */
        // 后端状态：0草稿 1待执行 2执行中 3已完成 4已暂停(人工/截止，需手动继续) 5失败 6已暂停(触达上限，自动继续)
        const STATUS_TABS = { all: '全部', draft: '草稿', pending: '待执行', running: '执行中', done: '已完成', paused: '已暂停', paused_freq: '触达上限' }
        const STATUS_CLS = { 0: 'ops-badge-draft', 1: 'ops-badge-running', 2: 'ops-badge-running', 3: 'ops-badge-done', 4: 'ops-badge-paused', 5: 'ops-badge-draft', 6: 'ops-badge-paused-auto' }
        const STATUS_FILTER = { draft: 0, pending: 1, running: 2, done: 3, paused: 4, paused_freq: 6 }

        /* ============== 任务数据 ============== */
        const tasks = ref([])
        const total = ref(0)
        const loading = ref(false)
        const state = reactive({ status: 'all', kw: '', page: 1, page_size: 10 })
        let searchTimer = null
        const onSearch = () => {
            if (searchTimer) clearTimeout(searchTimer)
            searchTimer = setTimeout(() => { state.page = 1; getList() }, 300)
        }
        const setStatus = (key) => { state.status = key; state.page = 1; getList() }
        const onPageChange = (page) => { state.page = page; getList() }
        const onSizeChange = (size) => { state.page_size = size; state.page = 1; getList() }

        const getList = () => {
            loading.value = true
            const params = { page: state.page, page_size: state.page_size }
            if (state.status !== 'all') params.status = STATUS_FILTER[state.status]
            if ((state.kw || '').trim()) params.keyword = state.kw.trim()
            newgetcrowdopslist(params).then((response) => {
                loading.value = false
                if (response.data.msg.code == 0) {
                    const d = response.data.data || {}
                    total.value = d.total || 0
                    tasks.value = (d.list || []).map(i => ({
                        id: i.id,
                        name: i.name,
                        status: i.status,
                        status_label: i.status_label,
                        pause_reason: i.pause_reason || '',
                        action_type: i.action_type,
                        send_channel: i.send_channel,
                        audience_names: i.audience_names || [],
                        trigger_type: i.trigger_type,
                        execute_at: i.execute_at,
                        cover_count: i.cover_count,
                        sent_amount: i.sent_amount,
                        wakeup_amount: i.wakeup_amount || 0,
                        to_send_amount: i.to_send_amount,
                        sent_failed_amount: i.sent_failed_amount,
                        bulk_status_code: i.bulk_status_code,
                        created_at: i.created_at
                    }))
                }
            }).catch(() => { loading.value = false })
        }

        /* ============== 筛选 ============== */
        const filteredTasks = computed(() => tasks.value)

        /* ============== KPI（后端统计，平台全量） ============== */
        const kpi = reactive({ total: 0, running: 0, runningRate: 0, reach: 0, cover: 0, conv: 0, convRate: '0.00' })

        const getStats = () => {
            newgetcrowdopsstats().then((response) => {
                if (response.data.msg.code != 0) return
                const d = response.data.data || {}
                kpi.total = d.total || 0
                kpi.running = d.running || 0
                kpi.runningRate = d.running_rate || 0
                kpi.reach = d.sent_amount || 0
                kpi.cover = d.cover_count || 0
                kpi.conv = d.sent_failed_amount || 0
                kpi.convRate = Number(d.fail_rate || 0).toFixed(2)
            }).catch(() => {})
        }

        /* ============== 工具 ============== */
        const fmtInt = (v) => Math.round(v || 0).toLocaleString('en-US')
        const fmtWan = (v) => {
            if (!v) return '0'
            if (v >= 10000) return (v / 10000).toFixed(1).replace(/\.0$/, '') + '万'
            return fmtInt(v)
        }

        /* ============== 操作 ============== */
        const goCreate = () => router.push({ path: '/navkh/crowdopstask' })
        // 仅草稿可继续编辑：带 id 进入任务页回填
        const goEdit = (row) => router.push({ path: '/navkh/crowdopstask', query: { id: row.id } })

        // 暂停原因提示：4=人工/截止暂停，6=触达上限暂停（次日自动继续）
        const PAUSE_REASON_TEXT = {
            manual: '手动暂停，需手动继续',
            cutoff: '到达发送截止时间，需手动继续',
            freq: '触达上限暂停，次日配额恢复后自动继续'
        }
        const pauseTip = (row) => {
            if (!row || (row.status !== 4 && row.status !== 6)) return ''
            return PAUSE_REASON_TEXT[row.pause_reason] || (row.status === 6 ? '触达上限暂停，次日自动继续' : '任务已暂停，可手动继续')
        }

        const pauseTask = (row) => {
            newpausecrowdops({ id: row.id }).then((response) => {
                const msg = response.data.msg || {}
                if (msg.code == 0) {
                    ElMessage.success('任务已暂停')
                    getList()
                    getStats()
                } else {
                    ElMessage.error(msg.info || '暂停失败')
                }
            }).catch(() => { ElMessage.error('暂停失败') })
        }

        const resumeTask = (row) => {
            newresumecrowdops({ id: row.id }).then((response) => {
                const msg = response.data.msg || {}
                if (msg.code == 0) {
                    ElMessage.success('任务已继续')
                    getList()
                    getStats()
                } else {
                    ElMessage.error(msg.info || '继续失败')
                }
            }).catch(() => { ElMessage.error('继续失败') })
        }

        /* ============== 详情弹窗 ============== */
        const detailVisible = ref(false)
        const detailLoading = ref(false)
        const detail = ref(null)

        const safeDecode = (s) => {
            try { return decode(s || '') } catch (e) { return '' }
        }

        const cxText = computed(() => {
            const d = detail.value
            if (!d) return '—'
            if (d.cx_mode === 'cutoff') return '发送截止 ' + (d.cx_cutoff || '—') + ' 后自动暂停'
            if (d.cx_mode === 'quiet') return '免打扰时段 ' + (d.cx_from || '—') + ' ~ ' + (d.cx_to || '—')
            return '未开启'
        })

        const detailContent = computed(() => {
            const list = (detail.value && detail.value.content) || []
            return list.map(i => ({
                type: i.msg_type,
                img: i.msg_type === 'Picture' ? (i.thumbUrl || safeDecode(i.content)) : '',
                text: i.msg_type === 'Text' ? safeDecode(i.content) : ''
            }))
        })

        const openDetail = (row) => {
            detailVisible.value = true
            detailLoading.value = true
            detail.value = null
            newgetcrowdopsdetail({ id: row.id }).then((response) => {
                detailLoading.value = false
                if (response.data.msg.code == 0) {
                    detail.value = response.data.data
                } else {
                    ElMessage.error(response.data.msg.info || '详情加载失败')
                }
            }).catch(() => { detailLoading.value = false; ElMessage.error('详情加载失败') })
        }

        onMounted(() => { getList(); getStats() })

        return {
            tasks, total, loading, state,
            STATUS_TABS, STATUS_CLS,
            onSearch, setStatus, onPageChange, onSizeChange, filteredTasks,
            kpi, getStats, fmtInt, fmtWan,
            goCreate, goEdit, pauseTip, pauseTask, resumeTask,
            detailVisible, detailLoading, detail,
            cxText, detailContent, openDetail
        }
    }
}
</script>

<style scoped>
.ops-page {
    --bg: #F7F8FC;
    --card: #ffffff;
    --primary: #4F46E5;
    --primary2: #7C3AED;
    --primarySoft: #A5B4FC;
    --red: #EF4444;
    --green: #10B981;
    --amber: #F59E0B;
    --text: #1E293B;
    --muted: #64748B;
    --grid: #EEF1F6;
    --border: #E8ECF3;
    --shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    --radius: 14px;
}
.grow { flex: 1; }
.ops-crumb { font-size: 13px; color: var(--muted); margin-bottom: 10px; }
.ops-crumb b { color: var(--text); }
.ops-head { display: flex; align-items: center; gap: 14px; margin-bottom: 18px; }
.page-title { font-size: 20px; font-weight: 800; margin: 0; }
.page-title small { font-weight: 500; color: var(--muted); font-size: 13px; margin-left: 10px; }
.btn-primary { background: linear-gradient(90deg, var(--primary), var(--primary2)); color: #fff; border: 0; border-radius: 10px; padding: 9px 18px; font-weight: 700; cursor: pointer; font-size: 13px; display: inline-flex; align-items: center; gap: 6px; }
.btn-primary:hover { opacity: .92; }

/* KPI */
.ops-kpi-row { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 20px; }
.ops-kpi-card { background: var(--card); border-radius: var(--radius); box-shadow: var(--shadow); padding: 18px; display: flex; gap: 14px; align-items: center; }
.ops-kpi-ico { width: 46px; height: 46px; border-radius: 12px; display: grid; place-items: center; color: #fff; flex-shrink: 0; }
.ops-kpi-num { font-size: 24px; font-weight: 800; line-height: 1; }
.ops-kpi-label { font-size: 12.5px; color: var(--muted); margin-top: 4px; }
.ops-kpi-sub { font-size: 11.5px; margin-top: 6px; font-weight: 600; }
.ops-kpi-sub.up { color: var(--green); }
.ops-kpi-sub.flat { color: var(--muted); }

/* 工具栏 */
.ops-toolbar { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 14px; }
.ops-select { padding: 9px 12px; border: 1px solid var(--border); border-radius: 10px; font-size: 13.5px; color: var(--text); background: #fff; font-family: inherit; }
.ops-select:focus { outline: none; border-color: var(--primary); }
.ops-search { display: flex; align-items: center; gap: 8px; padding: 0 12px; background: #fff; border: 1px solid var(--border); border-radius: 10px; }
.ops-filter-note { font-size: 12px; color: var(--muted); font-weight: 600; }
.ops-search input { border: 0; padding: 9px 0; font-size: 13.5px; outline: none; width: 200px; background: transparent; }
.ops-tabs2 { display: flex; gap: 6px; background: #fff; border: 1px solid var(--border); border-radius: 10px; padding: 4px; }
.ops-tab2 { padding: 7px 14px; border-radius: 8px; font-size: 13px; font-weight: 700; color: var(--muted); cursor: pointer; border: 0; background: transparent; }
.ops-tab2.active { background: linear-gradient(90deg, var(--primary), var(--primary2)); color: #fff; }

/* 表格 */
.ops-tbl-card { background: var(--card); border-radius: var(--radius); box-shadow: var(--shadow); overflow: hidden; padding: 6px 4px; }
.name-cell { font-weight: 700; color: var(--text); }
.muted-cell { color: var(--muted); }
.act-chip, .ch-chip { display: inline-block; font-size: 12px; font-weight: 700; padding: 3px 9px; border-radius: 999px; margin: 2px 4px 2px 0; white-space: nowrap; }
.eff-trio { display: flex; gap: 14px; }
.eff-trio .eff-item b { display: block; font-weight: 800; font-size: 13.5px; line-height: 1.25; color: var(--text); }
.eff-trio .eff-item i { display: block; font-style: normal; font-size: 11px; font-weight: 600; color: var(--muted); margin-top: 1px; }
.eff-trio .eff-item.key b { color: var(--green); }
/* 表头释义问号 */
.th-tip { display: inline-flex; align-items: center; gap: 6px; cursor: help; }
.th-tip .tip-ico { flex: 0 0 auto; width: 14px; height: 14px; border-radius: 50%; background: #CBD5E1; color: #fff; font-size: 10px; font-weight: 800; line-height: 14px; text-align: center; font-style: normal; transition: background .15s; }
.th-tip:hover .tip-ico { background: var(--primary); }
.th-tip-box em { font-style: normal; font-weight: 800; color: #A5B4FC; }
.ops-badge { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 700; padding: 4px 11px; border-radius: 999px; white-space: nowrap; }
.ops-badge::before { content: ""; width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
.ops-badge-draft { color: #64748B; background: rgba(100, 116, 139, .12); }
.ops-badge-running { color: #10B981; background: rgba(16, 185, 129, .12); }
.ops-badge-done { color: #4F46E5; background: rgba(79, 70, 229, .12); }
.ops-badge-paused { color: #F59E0B; background: rgba(245, 158, 11, .12); }
.ops-badge-paused-auto { color: #EA580C; background: rgba(234, 88, 12, .12); }
.op { color: var(--primary); font-weight: 600; cursor: pointer; margin-right: 12px; font-size: 13px; white-space: nowrap; }
.op:hover { text-decoration: underline; }
.op-pause { color: #D97706; }
.op-resume { color: var(--green); }
.ops-pager { display: flex; justify-content: flex-end; padding: 14px 12px 10px; }

/* 详情弹窗 */
.detail-body { min-height: 120px; }
.detail-title { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.detail-name { font-size: 16px; font-weight: 800; color: var(--text); }
.detail-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.detail-item { background: #FAFBFE; border: 1px solid var(--border); border-radius: 10px; padding: 10px 12px; }
.detail-item.full { grid-column: 1 / -1; }
.detail-item label { display: block; font-size: 11.5px; color: var(--muted); font-weight: 600; margin-bottom: 3px; }
.detail-item span { font-size: 13.5px; font-weight: 700; color: var(--text); }
.detail-content { margin-top: 14px; }
.detail-content > label { display: block; font-size: 12px; font-weight: 700; color: var(--muted); margin-bottom: 8px; }
.detail-empty { font-size: 12.5px; color: var(--muted); }
.detail-msg { margin-bottom: 10px; }
.detail-img { max-width: 220px; max-height: 220px; border-radius: 10px; border: 1px solid var(--border); display: block; }
.detail-text { font-size: 13px; color: var(--text); line-height: 1.7; white-space: pre-wrap; word-break: break-all; background: #FAFBFE; border: 1px solid var(--border); border-radius: 10px; padding: 10px 12px; }

@media (max-width: 1180px) {
    .ops-kpi-row { grid-template-columns: repeat(2, 1fr); }
}
</style>
